import React, { useEffect, useState } from 'react';
import {
    FormattedMessage,
    FormattedNumber,
    WrappedComponentProps,
    injectIntl,
} from 'react-intl';
import DeleteModal from './modals/delete-modal';
import {
    IDeleteLine,
    IItemImage,
    IODCartItem,
    IOrderDetails,
    IOrderDetailsLine,
    IUpdateOptionData,
} from '../../../models/order';
import {
    lineItemPTTrue,
    lineItemPTFalse,
    loadOrder,
    updateOptionData,
    updateSelect,
} from '../../../store/order/order-actions';
import { loadReturningProductDetails } from '../../../store/product/product-detail-actions';
import { ISession } from '../../../models/pro-sites';
import moment from 'moment';
import LineItemPizzaTracker from './pizza-trackers/line-item-pizza-tracker';
import { connect } from 'react-redux';
import { RootState } from '../../../store';
import { setIsBusy } from '../../../store/api/api-status-action';
import UpdateDetails from './update-details';
import { orderHold } from '../../../api/order-api';
import cart from '../../e-store/cart/cart';
import { hasFeature } from '../../authorization/features';
import { EXPECTED_SHIP_DATE } from '../../../models/feature-constants';

interface ILineItemDisplayProps {
    order: IOrderDetails | null | undefined;
    selected: number;
    session: ISession | null;
    lineItemPT: boolean;
    picked: boolean;
    loadReturningProductDetails: (
        partNumber: string,
        orderNumber: string
    ) => Promise<boolean>;
    lineItemPTTrue: () => { type: string };
    lineItemPTFalse: () => { type: string };
    loadOrder: (orderNumber: string) => Promise<void>;
    setIsBusy: (isBusy: boolean) => Promise<void>;
    updateOptionData: (updateOptionData: IUpdateOptionData) => {
        type: string;
        result: IUpdateOptionData;
    };
    updateSelect: (select: number) => { type: string };
    shippingSelected: number;
}
export const LineItemDisplay = ({
    order,
    selected,
    lineItemPT,
    session,
    shippingSelected,
    lineItemPTTrue,
    lineItemPTFalse,
    loadOrder,
    setIsBusy,
    loadReturningProductDetails,
    updateOptionData,
    updateSelect,
}: ILineItemDisplayProps) => {
    let reducedValues: IOrderDetailsLine[][] = [];
    const [itemImage, setItemImage] = useState<IItemImage | undefined>(
        undefined
    );
    const [lineToDelete, setLineToDelete] = useState<IDeleteLine | undefined>(
        undefined
    );
    const [deleteSelected, setDeleteSelected] = useState<number | undefined>(
        undefined
    );
    const [groupedLineItems, setGroupedLineItems] =
        useState<IOrderDetailsLine[][]>(reducedValues);
    const [pairNumber, setPairNumber] = useState<number | null>(null);
    const [nullESDs, setNullESDs] = useState<IOrderDetailsLine[]>([]);
    const statusArr: string[] = [];
    const [update, setUpdate] = useState(false);
    let lineItem = order!.lineItems[0];
    let pairItem: IOrderDetailsLine;
    let dataToSend: IUpdateOptionData;
    /**
    kick ass reducer that takes an order and groups the line
items by their expected ship date and then returns
arrays for each group */

    useEffect(() => {
        const reduced = order!.lineItems.reduce(
            function (
                groupedExpectedShipDates: {
                    hasExpectedShipDate: {
                        [key: string]: IOrderDetailsLine[];
                    };
                    nullExpectedShipDate: IOrderDetailsLine[];
                },
                orderDetailLine: IOrderDetailsLine
            ) {
                const { expectedShipDate } = orderDetailLine;
                if (expectedShipDate !== null) {
                    groupedExpectedShipDates.hasExpectedShipDate[
                        expectedShipDate
                    ] = groupedExpectedShipDates.hasExpectedShipDate[
                        expectedShipDate
                    ]
                        ? [
                              ...groupedExpectedShipDates.hasExpectedShipDate[
                                  expectedShipDate
                              ],
                              orderDetailLine,
                          ]
                        : [orderDetailLine];
                } else {
                    groupedExpectedShipDates.nullExpectedShipDate = [
                        ...groupedExpectedShipDates.nullExpectedShipDate,
                        orderDetailLine,
                    ];
                }
                return groupedExpectedShipDates;
            },
            {
                hasExpectedShipDate: {},
                nullExpectedShipDate: [],
            }
        );
        // const { hasExpectedShipDate, nullExpectedShipDate } = reduced;
        reducedValues = Object.values(reduced.hasExpectedShipDate);
        setGroupedLineItems(reducedValues);
        setNullESDs(reduced.nullExpectedShipDate);
    }, []);
    /*
    ATTENTION ATTENTION 9/2/2021 
comment out lineItemPT true until expected ship date returns
This code turns on whether or not the pizza tracker will be at the top or bottom
    useEffect(() => {
        if (order!.lineItems.find(item => item.expectedShipDate !== null)) {
            lineItemPTTrue();
        } else {
            lineItemPTFalse();
        }
        if (groupedLineItems.length <= 1) {
            lineItemPTFalse();
        }
        if (order!.orderType === 'Hearing Aid Order') {
            lineItemPTFalse();
        }
        if (order!.oracleOrderStatus === 'Cancelled') {
            lineItemPTFalse();
        }
    }, [order, groupedLineItems]);
*/
    useEffect(() => {
        return () => {
            lineItemPTFalse();
        };
    }, []);
    useEffect(() => {
        /* checking to see if the cartItem contains a pair
        if it does contain a pair match it to the partNumber and set it equal to 
        the line Item id -- this will allow the first option on a binaural pair 
        to 'edit options' but not the second */
        order!.lineItems.forEach((item) => {
            if (order!.cartItems) {
                order!.cartItems.map((cartItem) => {
                    if (
                        cartItem.pair &&
                        //cicemt !== cicem
                        cartItem.pair.id === item.cartItemId
                    ) {
                        setPairNumber(item.lineItemId!);
                    } else if (
                        !cartItem.pair &&
                        //cicemt !== cicem
                        cartItem.id === item.cartItemId
                    ) {
                        setPairNumber(item.lineItemId!);
                    }
                    return pairNumber;
                });
            }
        });
    }, [pairNumber, order]);
    /*
    const getPrice = (quantity: number, price: number) => {
        if (quantity >= 1) {
            return quantity * price;
        }
        return price;
    };
    */
    const getLineItemCount = (lineItems: IOrderDetailsLine[]) => {
        let value = 0;
        if (order!.orderStatus.toLowerCase() === 'cancelled') {
            return value;
        } else {
            lineItems.forEach(function (lineItem) {
                if (lineItem.quantity < 0) {
                    return value;
                }
                value += lineItem.quantity;
            });
        }

        return value;
    };
    const setSessionStorageItem = (key: string, serialNumber: string) => {
        sessionStorage.setItem(key, serialNumber);
    };

    const removeSessionStorageItem = (key: string) => {
        sessionStorage.removeItem(key);
    };

    /* const onReorder = (lineItems: IOrderDetailsLine[]) => {
        reorder(lineItems);
    };*/
    const statusCheck = (status: string) => {
        if (session && !session.isAccountThirdParty) {
            const lowerStatus = status.toLowerCase();
            if (
                lowerStatus === 'entered' ||
                lowerStatus === 'booked' ||
                lowerStatus === 'awaiting_shipping' ||
                lowerStatus === 'awaiting_fulfillment'
            ) {
                if (
                    order!.isCustom &&
                    order!.orderStatus.toLowerCase() === 'submitted'
                ) {
                    return true;
                } else if (!order!.isCustom) {
                    return true;
                }
            }
        }
        return false;
    };
    const deleteEligible = (item: IOrderDetailsLine) => {
        if (
            selected === 5 &&
            item.cancelEligible === 'Y' &&
            item.quantity > 0 &&
            !item.isCustom &&
            !session!.isAccountThirdParty
        ) {
            return true;
        }
        return false;
    };
    const updateOptions = async (
        cartItemId: string,
        lineItemId: number,
        partNumber: string
    ) => {
        let cartItem: IODCartItem;

        if (order!.cartItems.find((item) => item.id === cartItemId)!) {
            cartItem = order!.cartItems.find((item) => item.id === cartItemId)!;
        } else {
            cartItem = order!.cartItems.find(
                (item) => item.pair!.id === cartItemId
            )!;
        }
        lineItem = order!.lineItems.find(
            (item) => item.lineItemId === lineItemId
        )!;
        dataToSend = {
            cart: order!.cart,
            cartItem: cartItem,
            lineItem: [lineItem],
            patient: lineItem.patient,
        };

        if (pairNumber && cartItem.pair) {
            pairItem = order!.lineItems.find(
                (item) =>
                    cartItemId !== item.cartItemId &&
                    item.partNumber === partNumber
            )!;

            dataToSend.lineItem.push(pairItem);
            dataToSend = {
                ...dataToSend,
                patient: dataToSend.lineItem[1].patient,
            };
        }

        setIsBusy(true);
        updateOptionData(dataToSend);
        await loadReturningProductDetails(
            cartItem.baseProductId,
            order!.orderNumber
        );
        setUpdate(true);
        setIsBusy(false);
    };
    const onDelete = (item: IOrderDetailsLine, orderNumber: string) => {
        setLineToDelete({
            orderNumber: orderNumber,
            lineItemId: item.lineItemId!,
        });
        if (item.imageUrl) {
            setItemImage({
                src: item.imageUrl,
                alt: item.description,
            });
        }

        setDeleteSelected(item.lineItemId!);
    };
    const checkItems = (lineItem: IOrderDetailsLine) => {
        if (order!.orderStatus !== 'Cancelled' && lineItem.quantity > 0) {
            return true;
        } else if (order!.orderStatus === 'Cancelled') {
            return true;
        }
        return false;
    };
    return (
        <>
            {!lineItemPT && order ? (
                <>
                    <div
                        className="row"
                        style={{
                            paddingTop: '0px',
                        }}
                    >
                        <div className="col-md-12">
                            <label className="control-label">
                                {getLineItemCount(order.lineItems)}{' '}
                                <FormattedMessage id="items" />
                            </label>
                        </div>
                    </div>
                    <div
                        className="row"
                        style={{
                            paddingTop: '20px',
                        }}
                    >
                        <div
                            className="col-md-8"
                            id="line-itemProductDescription"
                        >
                            <FormattedMessage id="Product_Description" />
                        </div>

                        <div
                            className="col-md-4"
                            id="line-itemProductQuantity"
                            style={{
                                textAlign: 'right',
                            }}
                        >
                            <FormattedMessage id="Quantity_Short" />
                        </div>
                    </div>
                    <hr
                        style={{
                            marginTop: '5px',
                            marginBottom: '10px',
                            padding: '0px',
                        }}
                    />
                    {order &&
                        order.lineItems &&
                        order.lineItems.map((item, index) => {
                            return (
                                <React.Fragment key={item.lineItemId!}>
                                    {checkItems(item) && (
                                        <>
                                            <div
                                                key={index}
                                                id="line-itemDisplay"
                                            >
                                                <div
                                                    className="row"
                                                    style={{
                                                        marginTop: '15px',
                                                    }}
                                                >
                                                    <div
                                                        className={
                                                            item.noLongerAvailable ===
                                                                'True' ||
                                                            item.noLongerAvailable ===
                                                                'N/A on Estore'
                                                                ? 'col-md-10'
                                                                : 'col-md-8'
                                                        }
                                                    >
                                                        <div className="row">
                                                            {item.imageUrl && (
                                                                <div
                                                                    className="col-xs-2"
                                                                    id="line-itemImage"
                                                                >
                                                                    <img
                                                                        alt={
                                                                            item.description
                                                                        }
                                                                        src={
                                                                            item.imageUrl
                                                                        }
                                                                        style={{
                                                                            width: '100%',
                                                                            height: 'auto',
                                                                        }}
                                                                    />
                                                                </div>
                                                            )}
                                                            <div
                                                                className={
                                                                    item.imageUrl
                                                                        ? 'col-md-4'
                                                                        : 'col-md-6'
                                                                }
                                                                id="line-itemDescription"
                                                            >
                                                                <label
                                                                    className="control-label"
                                                                    id="line-itemDescriptionLabel"
                                                                >
                                                                    {
                                                                        item.description
                                                                    }
                                                                </label>
                                                                {item.noLongerAvailable ===
                                                                    'True' && (
                                                                    <div>
                                                                        <span className="fa fa-exclamation-triangle cancel-icon"></span>
                                                                        <i id="line-itemNoLongerAvailable">
                                                                            <FormattedMessage
                                                                                id="This_item_is_no_longer_available_obsolete"
                                                                                defaultMessage="This item is no longer available for purchase"
                                                                            />
                                                                        </i>
                                                                    </div>
                                                                )}
                                                                {item.noLongerAvailable ===
                                                                    'N/A on Estore' && (
                                                                    <div>
                                                                        {' '}
                                                                        <span className="fa fa-exclamation-triangle cancel-icon"></span>
                                                                        <i id="line-itemNoLongerAvailable">
                                                                            <FormattedMessage
                                                                                id="This_item_is_no_longer_available"
                                                                                defaultMessage="This item is currently not available for purchase on eStore"
                                                                            />
                                                                        </i>
                                                                    </div>
                                                                )}
                                                                {/* TO DO ADD CUSTOM CHECK  !item.isCustom &&  */}
                                                                {item.option &&
                                                                    item.option
                                                                        .length >
                                                                        0 &&
                                                                    pairNumber ===
                                                                        item.lineItemId! &&
                                                                    statusCheck(
                                                                        item.status
                                                                    ) && (
                                                                        <div>
                                                                            <button
                                                                                className="delete-items"
                                                                                onClick={() => {
                                                                                    updateOptions(
                                                                                        item.cartItemId,
                                                                                        item.lineItemId!,
                                                                                        item.partNumber
                                                                                    );
                                                                                }}
                                                                            >
                                                                                <FormattedMessage
                                                                                    id="Edit_Options"
                                                                                    defaultMessage="Edit Options"
                                                                                />
                                                                            </button>
                                                                        </div>
                                                                    )}

                                                                {item.serialNumbers &&
                                                                    item
                                                                        .serialNumbers
                                                                        .length >
                                                                        0 && (
                                                                        <div>
                                                                            <FormattedMessage id="Serial_N" />
                                                                            {item.serialNumbers.map(
                                                                                (
                                                                                    serialNumber,
                                                                                    idx
                                                                                ) => {
                                                                                    return (
                                                                                        <span
                                                                                            key={
                                                                                                idx
                                                                                            }
                                                                                            id={
                                                                                                'item-lineSerialNumber' +
                                                                                                serialNumber
                                                                                            }
                                                                                        >
                                                                                            {' ' +
                                                                                                serialNumber}
                                                                                            {idx ===
                                                                                            item
                                                                                                .serialNumbers
                                                                                                .length -
                                                                                                1
                                                                                                ? ''
                                                                                                : ','}
                                                                                        </span>
                                                                                    );
                                                                                }
                                                                            )}
                                                                        </div>
                                                                    )}
                                                            </div>
                                                            {item.option &&
                                                                item.option
                                                                    .length >
                                                                    0 && (
                                                                    <div className="col-md-4 product-description-body">
                                                                        <label
                                                                            className="control-label"
                                                                            id="line-itemProductOptionsLabel"
                                                                        >
                                                                            <FormattedMessage
                                                                                id="Product_Options"
                                                                                defaultMessage="Product Options"
                                                                            />
                                                                            {
                                                                                ': '
                                                                            }
                                                                        </label>

                                                                        {item.option.map(
                                                                            (
                                                                                option,
                                                                                i
                                                                            ) => {
                                                                                return (
                                                                                    <div
                                                                                        key={
                                                                                            i
                                                                                        }
                                                                                    >
                                                                                        <p
                                                                                            className="control-label"
                                                                                            id="line-itemOption"
                                                                                        >
                                                                                            {
                                                                                                option.name
                                                                                            }
                                                                                        </p>
                                                                                    </div>
                                                                                );
                                                                            }
                                                                        )}
                                                                    </div>
                                                                )}
                                                        </div>
                                                    </div>
                                                    <div
                                                        className={
                                                            item.noLongerAvailable ===
                                                                'True' ||
                                                            item.noLongerAvailable ===
                                                                'N/A on Estore'
                                                                ? 'col-md-2'
                                                                : 'col-md-4'
                                                        }
                                                        style={{
                                                            textAlign: 'right',
                                                        }}
                                                    >
                                                        {deleteEligible(
                                                            item
                                                        ) ? (
                                                            <>
                                                                <span id="line-itemQuantity">
                                                                    {order.orderStatus.toLowerCase() !==
                                                                    'cancelled' ? (
                                                                        <FormattedNumber
                                                                            value={
                                                                                item.quantity
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        <FormattedNumber
                                                                            value={
                                                                                0
                                                                            }
                                                                        />
                                                                    )}
                                                                </span>
                                                                <div>
                                                                    <button
                                                                        value={
                                                                            item.lineItemId
                                                                        }
                                                                        className="delete-items"
                                                                        onClick={() =>
                                                                            onDelete(
                                                                                item,
                                                                                order.orderNumber
                                                                            )
                                                                        }
                                                                        id="line-itemDeleteBtn"
                                                                    >
                                                                        <FormattedMessage
                                                                            id="Delete_Item(s)"
                                                                            defaultMessage="Delete Item(s)"
                                                                        />
                                                                    </button>
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <span id="line-itemQuantity">
                                                                {order.orderStatus.toLowerCase() !==
                                                                'cancelled' ? (
                                                                    <FormattedNumber
                                                                        value={
                                                                            item.quantity
                                                                        }
                                                                    />
                                                                ) : (
                                                                    <FormattedNumber
                                                                        value={
                                                                            0
                                                                        }
                                                                    />
                                                                )}
                                                            </span>
                                                        )}
                                                    </div>
                                                    {deleteSelected ===
                                                        item.lineItemId! && (
                                                        <DeleteModal
                                                            itemImage={
                                                                itemImage
                                                            }
                                                            lineToDelete={
                                                                lineToDelete!
                                                            }
                                                            order={order}
                                                            onAccept={() => {
                                                                setDeleteSelected(
                                                                    undefined
                                                                );
                                                                updateSelect(0);
                                                                setIsBusy(true);
                                                                loadOrder(
                                                                    order.orderNumber
                                                                ).then(() => {
                                                                    setIsBusy(
                                                                        false
                                                                    );
                                                                });
                                                            }}
                                                            onClose={() => {
                                                                setDeleteSelected(
                                                                    undefined
                                                                );
                                                            }}
                                                        />
                                                    )}
                                                    {/**
                                            {item.price !== 0 &&
                                                session!.userBuckets.includes(
                                                    23
                                                ) && (
                                                    <div
                                                        className="col-md-2"
                                                        style={{
                                                            textAlign: 'right'
                                                        }}
                                                    >
                                                        {intl.formatNumber(
                                                            getPrice(
                                                                item.quantity,
                                                                item.price
                                                            ),
                                                            {
                                                                style:
                                                                    'currency',
                                                                currency: 'USD'
                                                            }
                                                        )}
                                                    </div>
                                                )}
                                                 */}
                                                </div>

                                                <hr
                                                    style={{
                                                        marginTop: '10px',
                                                        marginBottom: '10px',
                                                        padding: '0px',
                                                    }}
                                                />
                                            </div>
                                        </>
                                    )}
                                </React.Fragment>
                            );
                        })}
                </>
            ) : (
                <>
                    <div
                        className="row"
                        style={{
                            paddingTop: '0px',
                        }}
                    >
                        {' '}
                        <div className="col-md-12">
                            <label className="control-label">
                                {getLineItemCount(order!.lineItems)}{' '}
                                <FormattedMessage id="items" />
                            </label>
                        </div>
                    </div>

                    {groupedLineItems.map((array, i) => {
                        array.map((lineItem) =>
                            statusArr.push(lineItem.status)
                        );

                        return (
                            <React.Fragment key={i}>
                                <div className="shipmentTrackHead">
                                    <h4>
                                        <span className="fa fa-truck"></span>
                                        {'Expected Ship Date: ' +
                                            moment(
                                                array[0].expectedShipDate
                                            ).format('MMM DD, YYYY')}
                                    </h4>
                                </div>

                                <div>
                                    <LineItemPizzaTracker
                                        lineStatusArray={statusArr}
                                        order={order!}
                                    />
                                </div>

                                <div
                                    className="row"
                                    style={{
                                        paddingTop: '20px',
                                    }}
                                >
                                    <div
                                        className="col-md-8"
                                        id="line-itemProductDescription"
                                    >
                                        <FormattedMessage id="Product_Description" />
                                    </div>

                                    <div
                                        className="col-md-4"
                                        id="line-itemProductQuantity"
                                        style={{
                                            textAlign: 'right',
                                        }}
                                    >
                                        <FormattedMessage id="Quantity_Short" />
                                    </div>
                                </div>
                                <hr
                                    style={{
                                        marginTop: '5px',
                                        marginBottom: '10px',
                                        padding: '0px',
                                    }}
                                />

                                <>
                                    {array.map((item, index) => {
                                        return (
                                            <React.Fragment
                                                key={item.lineItemId!}
                                            >
                                                <div
                                                    key={index}
                                                    id="line-itemDisplay"
                                                >
                                                    <div
                                                        className="row"
                                                        style={{
                                                            marginTop: '15px',
                                                        }}
                                                    >
                                                        <div
                                                            className={
                                                                item.noLongerAvailable ===
                                                                    'True' ||
                                                                item.noLongerAvailable ===
                                                                    'N/A on Estore'
                                                                    ? 'col-md-10'
                                                                    : 'col-md-8'
                                                            }
                                                        >
                                                            <div className="row">
                                                                {item.imageUrl && (
                                                                    <div
                                                                        className="col-xs-2"
                                                                        id="line-itemImage"
                                                                    >
                                                                        <img
                                                                            alt={
                                                                                item.description
                                                                            }
                                                                            src={
                                                                                item.imageUrl
                                                                            }
                                                                            style={{
                                                                                width: '100%',
                                                                                height: 'auto',
                                                                            }}
                                                                        />
                                                                    </div>
                                                                )}
                                                                <div
                                                                    className={
                                                                        item.imageUrl
                                                                            ? 'col-md-4'
                                                                            : 'col-md-6'
                                                                    }
                                                                    id="line-itemDescription"
                                                                >
                                                                    <label
                                                                        className="control-label"
                                                                        id="line-itemDescriptionLabel"
                                                                    >
                                                                        {
                                                                            item.description
                                                                        }
                                                                    </label>
                                                                    {item.noLongerAvailable ===
                                                                        'True' && (
                                                                        <div>
                                                                            <span className="fa fa-exclamation-triangle cancel-icon"></span>
                                                                            <i id="line-itemNoLongerAvailable">
                                                                                <FormattedMessage
                                                                                    id="This_item_is_no_longer_available_obsolete"
                                                                                    defaultMessage="This item is no longer available for purchase"
                                                                                />
                                                                            </i>
                                                                        </div>
                                                                    )}
                                                                    {item.noLongerAvailable ===
                                                                        'N/A on Estore' && (
                                                                        <div>
                                                                            {' '}
                                                                            <span className="fa fa-exclamation-triangle cancel-icon"></span>
                                                                            <i id="line-itemNoLongerAvailable">
                                                                                <FormattedMessage
                                                                                    id="This_item_is_no_longer_available"
                                                                                    defaultMessage="This item is currently not available for purchase on eStore"
                                                                                />
                                                                            </i>
                                                                        </div>
                                                                    )}
                                                                    {/* TO DO ADD CUSTOM CHECK  !item.isCustom &&  */}
                                                                    {item.option &&
                                                                        item
                                                                            .option
                                                                            .length >
                                                                            0 &&
                                                                        pairNumber ===
                                                                            item.lineItemId! &&
                                                                        statusCheck(
                                                                            item.status
                                                                        ) && (
                                                                            <div>
                                                                                <button
                                                                                    className="delete-items"
                                                                                    onClick={() => {
                                                                                        updateOptions(
                                                                                            item.cartItemId,
                                                                                            item.lineItemId!,
                                                                                            item.partNumber
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    <FormattedMessage
                                                                                        id="Edit_Options"
                                                                                        defaultMessage="Edit Options"
                                                                                    />
                                                                                </button>
                                                                            </div>
                                                                        )}

                                                                    {item.serialNumbers &&
                                                                        item
                                                                            .serialNumbers
                                                                            .length >
                                                                            0 && (
                                                                            <div>
                                                                                <FormattedMessage id="Serial_N" />
                                                                                {item.serialNumbers.map(
                                                                                    (
                                                                                        serialNumber,
                                                                                        idx
                                                                                    ) => {
                                                                                        return (
                                                                                            <span
                                                                                                key={
                                                                                                    idx
                                                                                                }
                                                                                                id={
                                                                                                    'item-lineSerialNumber' +
                                                                                                    serialNumber
                                                                                                }
                                                                                            >
                                                                                                {' ' +
                                                                                                    serialNumber}
                                                                                                {idx ===
                                                                                                item
                                                                                                    .serialNumbers
                                                                                                    .length -
                                                                                                    1
                                                                                                    ? ''
                                                                                                    : ','}
                                                                                            </span>
                                                                                        );
                                                                                    }
                                                                                )}
                                                                            </div>
                                                                        )}
                                                                </div>
                                                                {item.option &&
                                                                    item.option
                                                                        .length >
                                                                        0 && (
                                                                        <div className="col-md-4 product-description-body">
                                                                            <label
                                                                                className="control-label"
                                                                                id="line-itemProductOptionsLabel"
                                                                            >
                                                                                <FormattedMessage
                                                                                    id="Product_Options"
                                                                                    defaultMessage="Product Options"
                                                                                />
                                                                                {
                                                                                    ': '
                                                                                }
                                                                            </label>

                                                                            {item.option.map(
                                                                                (
                                                                                    option,
                                                                                    i
                                                                                ) => {
                                                                                    return (
                                                                                        <div
                                                                                            key={
                                                                                                i
                                                                                            }
                                                                                        >
                                                                                            <p
                                                                                                className="control-label"
                                                                                                id="line-itemOption"
                                                                                            >
                                                                                                {
                                                                                                    option.name
                                                                                                }
                                                                                            </p>
                                                                                        </div>
                                                                                    );
                                                                                }
                                                                            )}
                                                                        </div>
                                                                    )}
                                                            </div>
                                                        </div>

                                                        <div
                                                            className={
                                                                item.noLongerAvailable ===
                                                                    'True' ||
                                                                item.noLongerAvailable ===
                                                                    'N/A on Estore'
                                                                    ? 'col-md-2'
                                                                    : 'col-md-4'
                                                            }
                                                            style={{
                                                                textAlign:
                                                                    'right',
                                                            }}
                                                        >
                                                            {deleteEligible(
                                                                item
                                                            ) ? (
                                                                <>
                                                                    <span id="line-itemQuantity">
                                                                        {order!.orderStatus.toLowerCase() !==
                                                                        'cancelled' ? (
                                                                            <FormattedNumber
                                                                                value={
                                                                                    item.quantity
                                                                                }
                                                                            />
                                                                        ) : (
                                                                            <FormattedNumber
                                                                                value={
                                                                                    0
                                                                                }
                                                                            />
                                                                        )}
                                                                    </span>
                                                                    <div>
                                                                        <button
                                                                            value={
                                                                                item.lineItemId
                                                                            }
                                                                            className="delete-items"
                                                                            onClick={() =>
                                                                                onDelete(
                                                                                    item,
                                                                                    order!
                                                                                        .orderNumber
                                                                                )
                                                                            }
                                                                            id="line-itemDeleteBtn"
                                                                        >
                                                                            <FormattedMessage
                                                                                id="Delete_Item(s)"
                                                                                defaultMessage="Delete Item(s)"
                                                                            />
                                                                        </button>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <span id="line-itemQuantity">
                                                                    {order!.orderStatus.toLowerCase() !==
                                                                    'cancelled' ? (
                                                                        <FormattedNumber
                                                                            value={
                                                                                item.quantity
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        <FormattedNumber
                                                                            value={
                                                                                0
                                                                            }
                                                                        />
                                                                    )}
                                                                </span>
                                                            )}
                                                        </div>
                                                        {deleteSelected ===
                                                            item.lineItemId! &&
                                                            item.cancelEligible &&
                                                            item.quantity >
                                                                0 && (
                                                                <DeleteModal
                                                                    itemImage={
                                                                        itemImage
                                                                    }
                                                                    lineToDelete={
                                                                        lineToDelete!
                                                                    }
                                                                    order={
                                                                        order!
                                                                    }
                                                                    onAccept={() => {
                                                                        updateSelect(
                                                                            0
                                                                        );
                                                                        setDeleteSelected(
                                                                            undefined
                                                                        );
                                                                        setIsBusy(
                                                                            true
                                                                        );
                                                                        loadOrder(
                                                                            order!
                                                                                .orderNumber
                                                                        ).then(
                                                                            () => {
                                                                                setIsBusy(
                                                                                    false
                                                                                );
                                                                            }
                                                                        );
                                                                    }}
                                                                    onClose={() => {
                                                                        setDeleteSelected(
                                                                            undefined
                                                                        );
                                                                    }}
                                                                />
                                                            )}
                                                        {/**
                                                                {item.price !==
                                                                    0 &&
                                                                    session!.userBuckets.includes(
                                                                        23
                                                                    ) && (
                                                                        <div
                                                                            className="col-md-2"
                                                                            style={{
                                                                                textAlign:
                                                                                    'right'
                                                                            }}
                                                                        >
                                                                            {intl.formatNumber(
                                                                                getPrice(
                                                                                    item.quantity,
                                                                                    item.price
                                                                                ),
                                                                                {
                                                                                    style:
                                                                                        'currency',
                                                                                    currency:
                                                                                        'USD'
                                                                                }
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                 */}
                                                    </div>

                                                    <hr
                                                        style={{
                                                            marginTop: '10px',
                                                            marginBottom:
                                                                '10px',
                                                            padding: '0px',
                                                        }}
                                                    />
                                                </div>
                                            </React.Fragment>
                                        );
                                    })}
                                </>
                            </React.Fragment>
                        );
                    })}
                    {nullESDs.map((item, index) => {
                        statusArr.push(item.status);
                        let shippable = false;
                        if (item.shippableFlag === 'Y') {
                            shippable = true;
                        }
                        return (
                            <React.Fragment key={item.lineItemId!}>
                                {shippable && (
                                    <>
                                        <div className="shipmentTrackHead">
                                            <h4>
                                                <span className="fa fa-truck"></span>
                                                {hasFeature(
                                                    session!,
                                                    EXPECTED_SHIP_DATE
                                                ) && (
                                                    <FormattedMessage
                                                        id="Expected_Ship_Date"
                                                        defaultMessage="Expected Ship Date"
                                                    />
                                                )}
                                                {': '}
                                                <FormattedMessage
                                                    id="Pending"
                                                    defaultMessage="Pending"
                                                />
                                            </h4>
                                        </div>

                                        <div id="line-itemPizzaTracker">
                                            <LineItemPizzaTracker
                                                lineStatusArray={statusArr}
                                                order={order!}
                                            />
                                        </div>
                                    </>
                                )}
                                <div key={index} id="line-itemDisplay">
                                    <div
                                        className="row"
                                        style={{
                                            marginTop: '15px',
                                        }}
                                    >
                                        <div
                                            className={
                                                item.noLongerAvailable ===
                                                    'True' ||
                                                item.noLongerAvailable ===
                                                    'N/A on Estore'
                                                    ? 'col-md-10'
                                                    : 'col-md-8'
                                            }
                                        >
                                            <div className="row">
                                                {item.imageUrl && (
                                                    <div
                                                        className="col-xs-2"
                                                        id="line-itemImage"
                                                    >
                                                        <img
                                                            alt={
                                                                item.description
                                                            }
                                                            src={item.imageUrl}
                                                            style={{
                                                                width: '100%',
                                                                height: 'auto',
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                                <div
                                                    className={
                                                        item.imageUrl
                                                            ? 'col-md-4'
                                                            : 'col-md-6'
                                                    }
                                                    id="line-itemDescription"
                                                >
                                                    <label
                                                        className="control-label"
                                                        id="line-itemDescriptionLabel"
                                                    >
                                                        {item.description}
                                                    </label>
                                                    {item.noLongerAvailable ===
                                                        'True' && (
                                                        <div>
                                                            <span className="fa fa-exclamation-triangle cancel-icon"></span>
                                                            <i id="line-itemNoLongerAvailable">
                                                                <FormattedMessage
                                                                    id="This_item_is_no_longer_available_obsolete"
                                                                    defaultMessage="This item is no longer available for purchase"
                                                                />
                                                            </i>
                                                        </div>
                                                    )}
                                                    {item.noLongerAvailable ===
                                                        'N/A on Estore' && (
                                                        <div>
                                                            {' '}
                                                            <span className="fa fa-exclamation-triangle cancel-icon"></span>
                                                            <i id="line-itemNoLongerAvailable">
                                                                <FormattedMessage
                                                                    id="This_item_is_no_longer_available"
                                                                    defaultMessage="This item is currently not available for purchase on eStore"
                                                                />
                                                            </i>
                                                        </div>
                                                    )}
                                                    {item.option &&
                                                        item.option.length >
                                                            0 &&
                                                        pairNumber ===
                                                            item.lineItemId! &&
                                                        statusCheck(
                                                            item.status
                                                        ) && (
                                                            <div>
                                                                <button
                                                                    className="delete-items"
                                                                    onClick={() => {
                                                                        updateOptions(
                                                                            item.cartItemId,
                                                                            lineItem.lineItemId!,
                                                                            item.partNumber
                                                                        );
                                                                    }}
                                                                >
                                                                    <FormattedMessage
                                                                        id="Edit_Options"
                                                                        defaultMessage="Edit Options"
                                                                    />
                                                                </button>
                                                            </div>
                                                        )}

                                                    {item.serialNumbers &&
                                                        item.serialNumbers
                                                            .length > 0 && (
                                                            <div>
                                                                <FormattedMessage id="Serial_N" />
                                                                {item.serialNumbers.map(
                                                                    (
                                                                        serialNumber,
                                                                        idx
                                                                    ) => {
                                                                        return (
                                                                            <span
                                                                                key={
                                                                                    idx
                                                                                }
                                                                                id={
                                                                                    'item-lineSerialNumber' +
                                                                                    serialNumber
                                                                                }
                                                                            >
                                                                                {' ' +
                                                                                    serialNumber}
                                                                                {idx ===
                                                                                item
                                                                                    .serialNumbers
                                                                                    .length -
                                                                                    1
                                                                                    ? ''
                                                                                    : ','}
                                                                            </span>
                                                                        );
                                                                    }
                                                                )}
                                                            </div>
                                                        )}
                                                </div>
                                                {item.option &&
                                                    item.option.length > 0 && (
                                                        <div className="col-md-4 product-description-body">
                                                            <label
                                                                className="control-label"
                                                                id="line-itemProductOptionsLabel"
                                                            >
                                                                <FormattedMessage
                                                                    id="Product_Options"
                                                                    defaultMessage="Product Options"
                                                                />
                                                                {': '}
                                                            </label>

                                                            {item.option.map(
                                                                (option, i) => {
                                                                    return (
                                                                        <div
                                                                            key={
                                                                                i
                                                                            }
                                                                        >
                                                                            <p
                                                                                className="control-label"
                                                                                id="line-itemOption"
                                                                            >
                                                                                {
                                                                                    option.name
                                                                                }
                                                                            </p>
                                                                        </div>
                                                                    );
                                                                }
                                                            )}
                                                        </div>
                                                    )}
                                            </div>
                                        </div>

                                        <div
                                            className={
                                                item.noLongerAvailable ===
                                                    'True' ||
                                                item.noLongerAvailable ===
                                                    'N/A on Estore'
                                                    ? 'col-md-2'
                                                    : 'col-md-4'
                                            }
                                            style={{
                                                textAlign: 'right',
                                            }}
                                        >
                                            {deleteEligible(item) ? (
                                                <>
                                                    <span id="line-itemQuantity">
                                                        {order!.orderStatus.toLowerCase() !==
                                                        'cancelled' ? (
                                                            <FormattedNumber
                                                                value={
                                                                    item.quantity
                                                                }
                                                            />
                                                        ) : (
                                                            <FormattedNumber
                                                                value={0}
                                                            />
                                                        )}
                                                    </span>
                                                    <div>
                                                        <button
                                                            value={
                                                                item.lineItemId
                                                            }
                                                            className="delete-items"
                                                            onClick={() =>
                                                                onDelete(
                                                                    item,
                                                                    order!
                                                                        .orderNumber
                                                                )
                                                            }
                                                            id="line-itemDeleteBtn"
                                                        >
                                                            <FormattedMessage
                                                                id="Delete_Item(s)"
                                                                defaultMessage="Delete Item(s)"
                                                            />
                                                        </button>
                                                    </div>
                                                </>
                                            ) : (
                                                <span id="line-itemQuantity">
                                                    {order!.orderStatus.toLowerCase() !==
                                                    'cancelled' ? (
                                                        <FormattedNumber
                                                            value={
                                                                item.quantity
                                                            }
                                                        />
                                                    ) : (
                                                        <FormattedNumber
                                                            value={0}
                                                        />
                                                    )}
                                                </span>
                                            )}
                                        </div>
                                        {deleteSelected ===
                                            item.lineItemId! && (
                                            <DeleteModal
                                                itemImage={itemImage}
                                                lineToDelete={lineToDelete!}
                                                order={order!}
                                                onAccept={() => {
                                                    updateSelect(0);
                                                    setDeleteSelected(
                                                        undefined
                                                    );
                                                    setIsBusy(true);
                                                    loadOrder(
                                                        order!.orderNumber
                                                    ).then(() => {
                                                        setIsBusy(false);
                                                    });
                                                }}
                                                onClose={() => {
                                                    setDeleteSelected(
                                                        undefined
                                                    );
                                                }}
                                            />
                                        )}
                                        {/**
                                                                {item.price !==
                                                                    0 &&
                                                                    session!.userBuckets.includes(
                                                                        23
                                                                    ) && (
                                                                        <div
                                                                            className="col-md-2"
                                                                            style={{
                                                                                textAlign:
                                                                                    'right'
                                                                            }}
                                                                        >
                                                                            {intl.formatNumber(
                                                                                getPrice(
                                                                                    item.quantity,
                                                                                    item.price
                                                                                ),
                                                                                {
                                                                                    style:
                                                                                        'currency',
                                                                                    currency:
                                                                                        'USD'
                                                                                }
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                 */}
                                    </div>

                                    <hr
                                        style={{
                                            marginTop: '10px',
                                            marginBottom: '10px',
                                            padding: '0px',
                                        }}
                                    />
                                </div>
                            </React.Fragment>
                        );
                    })}
                </>
            )}

            {update && (
                <UpdateDetails
                    onAccept={() => {
                        orderHold(order!.orderNumber, false);
                        setIsBusy(true)
                            .then(() => {
                                loadOrder(order!.orderNumber);
                            })
                            .then(() => {
                                setUpdate(false);
                                setIsBusy(false);
                            });
                    }}
                    onClose={() => {
                        setUpdate(false);
                        orderHold(order!.orderNumber, false);
                    }}
                />
            )}
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        lineItemPT: state.lineItemPizzaTracker
            ? state.lineItemPizzaTracker
            : false,
        order: state.order ? state.order.data : null,
        selected: state.select,
    };
};
const mapDispatchToProps = {
    lineItemPTTrue,
    lineItemPTFalse,
    setIsBusy,
    loadOrder,
    loadReturningProductDetails,
    updateOptionData,
    updateSelect,
};

const lineItemDisplayContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(LineItemDisplay);

export default lineItemDisplayContainer;
